module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    primary: '#2b7abf',
                    blue: '#4ca1da',
                    lightblue: '#F0F9FF',
                    darkprimary: '#1665AA',
                    gray: '#9CA3AF',
                    black: '#101926',
                    green: '#22C55E',
                    darkgreen: '#12B24D',
                    orange: '#EF8F02',
                    lightorange: '#FDC868',
                }
            },
        },
        fontFamily: {
            inter: ['Inter', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
